import { Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { LandingConfigurationService } from "../../../src/core/services/landing_configuration_service";
import GeneralConfig from "../content/general_config/GeneralConfig";
import PageConfig from "../content/page_config/PageConfig";
import { openNotificationWithIcon } from "../../../src/utilities/notificationWithIcon";

// Refactor de portales: Eliminar este archivo

const LandingConfigurations = ({ organizationToken, tenantId }) => {
  const [landingConfig, setlandingConfig] = useState(null);

  const landingConfigService = new LandingConfigurationService();

  useEffect(() => {
    getLandingConfig();
  }, []);

  function getLandingConfig() {
    landingConfigService.getSingleRecord(
      organizationToken,
      tenantId,
      (response) => {
        setlandingConfig(response.data);
      },
      (err) => console.error(err)
    );
  }

  const handleUpdateLanding = (e, form) => {
    e.preventDefault()
    form.validateFields((err, values) => {
      const dataParams = {
        landing_configuration: values,
      };

      landingConfigService.updateRecord(
        landingConfig.id,
        dataParams,
        (response) => {
          openNotificationWithIcon("success", "Actualización correcta", "");
          setlandingConfig(response.data);
        },
        (err) => {
          openNotificationWithIcon(
            "error",
            "Lo sentimos!",
            "Ocurrió un error al actualizar los datos."
          );
        }
      );
    })
  };

  if (!!!landingConfig) {
    return (
      <Skeleton
        title={false}
        active={true}
        paragraph={{
          rows: 6,
        }}
      />
    );
  }

  return (
    <>
      <GeneralConfig
        landingConfig={landingConfig}
        handleUpdateLanding={handleUpdateLanding}
      />
      {landingConfig.landing_pages.map((landingPage) => {
        return <PageConfig landingPage={landingPage} />
      })}

    </>
  );
};

export default LandingConfigurations;
